import { useSelector } from 'react-redux'

import useReduxAction from '@hooks/useReduxAction'

import { isAdmin, isBrandUser, isMasterAdmin } from '@functions/user'

import { useRelations } from '@hooks/useUser'

type UseCurrentUserOptions = {
  performHttpRequests?: boolean,
}

function useCurrentUser(options: UseCurrentUserOptions = {}) {
  const { performHttpRequests } = options || {}

  useReduxAction(
    'currentUser',
    'loadCurrentUser',
    {
      include_user_association_id: true,
      include_user_frontend_permissions: true,
      include_user_teams_where_team_lead_ids: true,
    },
    [performHttpRequests],
    {
      // @ts-expect-error TS2322
      shouldPerformFn: (entityReducer) => {
        const { errors, loaded, loading } = entityReducer
        return performHttpRequests && !loaded && !loading && !errors.length
      },
    },
  )

  // @ts-expect-error TS18046
  const entityReducer = useSelector(reduxState => reduxState.currentUser)
  const { loaded, loading, result: currentUser } = entityReducer

  const currentUserRelations = useRelations(currentUser)
  const { role } = currentUserRelations

  const permissions = currentUser?.frontend_permissions?.admin ?? {}
  const teamsWhereTeamLeadIds = currentUser?.teams_where_team_lead_ids ?? []
  const isTeamLead = !!teamsWhereTeamLeadIds.length

  return {
    brandId: (currentUser as { brand_id?: number })?.brand_id,
    currentUser,
    // @ts-expect-error TS2345
    isAdmin: isAdmin(role.key),
    // @ts-expect-error TS2345
    isBrandUser: isBrandUser(role.key),
    // @ts-expect-error TS2345
    isMasterAdmin: isMasterAdmin(role.key),
    isTeamLead,
    loaded,
    loading,
    permissions,
    teamsWhereTeamLeadIds,
  }
}

export type CurrentUserPayload = ReturnType<typeof useCurrentUser>

export default useCurrentUser
